import type { TabsProps } from 'antd';

export const taskListTabs: TabsProps['items'] = [
  {
    key: 'registry',
    label: 'Реестр',
  },
  {
    key: 'day',
    label: 'День',
  },
  {
    key: 'week',
    label: 'Неделя',
  },
  {
    key: 'month',
    label: 'Месяц',
  },
];
